import Zoom from "react-medium-image-zoom";
import { TestIdClassNameProps } from "@app/types/Common";
import { Field, ImageProps, Relation } from "@app/types/Cue";
import { Name } from "@app/types/enums";
import { getFieldValue } from "@util/helpers";
import cx from "classnames";

import "react-medium-image-zoom/dist/styles.css";

export type ArticleInlineImageProps = TestIdClassNameProps & {
  fields: Field[];
  relation: Relation;
  annotation: string;
};

export default function ArticleInlineImage({
  testId,
  rootClassName,
  fields,
  relation,
  annotation,
}: ArticleInlineImageProps): React.ReactElement {
  // @TODO Include caption in the popup.
  const cropSelection = getFieldValue(fields, Name.CropSelection);
  const caption = getFieldValue(fields, Name.Caption);
  const alignment = getFieldValue(fields, Name.Alignment);
  const displayCaption = getFieldValue(fields, Name.DisplayCaption);
  const credit = getFieldValue(fields, Name.Credit);

  // More available data from CUE. We dont have a use of them, yet,
  // But we want to keep it here so we are aware of them.
  // const byline = getFieldValue(fields, Name.Byline);
  // const titleColor = getFieldValue(fields, Name.TitleColor);
  // const displayFullWidth = getFieldValue(fields, Name.DisplayFullWidth);
  // const convertToParallax = getFieldValue(fields, Name.ConvertToParallax);

  const { height, width, url } = relation.fields?.[
    `${cropSelection}-caas` as keyof typeof relation.fields
  ] as ImageProps;

  return (
    <div
      className={rootClassName}
      data-testid={testId}
      data-annotation={annotation}
    >
      <figure
        className={cx("table", {
          "mx-auto": alignment === "full" || alignment === "center",
          "ml-auto": alignment === "right",
        })}
      >
        <Zoom zoomMargin={32} classDialog="medium-zoom">
          <img
            src={url}
            height={height}
            width={width}
            className={cx("max-h-[30rem] w-auto max-w-full")}
            alt=""
          />
        </Zoom>

        {displayCaption && (caption || credit) ? (
          <figcaption className="mt-1 table-caption caption-bottom text-3xs text-gray-525">
            {caption} {credit}
          </figcaption>
        ) : null}
      </figure>
    </div>
  );
}
